export default __webpack_public_path__ + "static/two-robots-8cbc696746308c28252a3fe5e8e9d8c3.png";